import request from '../../request.js'
//e签宝 已签合同

export const getPageTableList = function (data) {
    return request({
        url: '/esignFile/getPageTableList',
        method: 'post',
        data
    })
}


//列表
export const getTableList = function (data) {
    return request({
        url: '/esignFile/getTableList',
        method: 'post',
        data
    })
}
//待签署列表
export const getToBeSignedTableList = function (data) {
    return request({
        url: '/esignFile/getToBeSignedTableList',
        method: 'post',
        data
    })
}

//根据id，获取信息
export const getObjectById = function (data) {
    return request({
        url: '/esignFile/getObjectById',
        method: 'post',
        data
    })
}